// @flow
import {
    GET_POWER_CONSUMPTION,
    HIDE_ESTIMATED_COST_MODAL,
    RECEIVE_POWER_CONSUMPTION,
    SHOW_ESTIMATED_COST_MODAL
} from './constants';

import { createAction } from 'redux-actions';

export const getPowerConsumption = createAction(GET_POWER_CONSUMPTION);
export const receivePowerConsumption = createAction(RECEIVE_POWER_CONSUMPTION);
export const showEstimatedCostModal = createAction(SHOW_ESTIMATED_COST_MODAL);
export const hideEstimatedCostModal = createAction(HIDE_ESTIMATED_COST_MODAL);



// WEBPACK FOOTER //
// ./src/core/state/power-consumption/actions.js